module.exports = __webpack_public_path__ + "static/media/img007.2ee9f0b2.jpg";